/* eslint-disable react/no-unescaped-entities */

import React from 'react'

import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => {
  const classList = {

    paper: {
      margin: theme.spacing(16, 4)

    },
    paragraph:
    {
      marginTop: 0,
      marginRight: 0,
      marginBottom: '8.0pt',
      marginLeft: 0,
      fontSize: 14
    }

  }

  return classList
})

const KVKK = () => {
  const classes = useStyles()
  return (
    <>
      <Grid container component="main">
        <Grid item xs={12}>
          <div className={classes.paper}>
            <p className={classes.paragraph}><span>Kişisel Verilerin Korunması Kanunu;</span></p>

            <p className={classes.paragraph}>
              <span>
                Kişisel verilerin korunması KOLAYYOLLA
                TEKNOLOJİ HİZMETLERİ DİJİTAL PAZARLAMA VE TİCARET ANONİM ŞİRKETİ (KolayYolla
                veya Şirket) için önemli takip edilen ve uygulanan bir konudur. Kanun ile
                kişisel verinin tanımı yapılarak, bunların korunmasına ilişkin ilkeler ve bu
                verilerin işlenmesinde veri sorumlusu sıfatı taşıyanların uyacakları şartlara
                yer verilmiştir. Kanun'a göre kişisel veri, &quot;gerçek kişi&quot; lere
                ilişkin her türlü bilgidir. Kişisel verilerin işlenmesi ise &quot;kişisel
                verilerin otomatik olan ya da herhangi bir veri kayıt sisteminin bir parçası
                olmak kaydıyla otomatik olmayan yollarla elde edilmesi, kaydedilmesi,
                depolanması, değiştirilmesi, üçüncü kişilerle paylaşılması ve yurtdışına
                transfer edilmesi dahil kişisel veriler üzerinde gerçekleştirilen her türlü
                işlemi&quot; ifade etmektedir.
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                KolayYolla, 6698 Sayılı Kişisel Verilerin
                Korunması Kanunu'na (&quot;KVK Kanunu&quot;) uyum sağlanması için KVK
                Kanunu'nun öngördüğü ilkeleri benimsemekte, kişisel verilerin işlenmesi,
                silinmesi, yok edilmesi, anonim hale getirilmesi, aktarılması, ilgili kişinin
                aydınlatılması ve veri güvenliğinin sağlanmasıyla ilgili yükümlülüklerini
                yerine getirmektedir.
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Kanun'un tamamının veya belirli maddelerinin
                yenilenmesi durumunda Kanun'un yürürlük tarihi güncellenecektir ve KolayYolla
                internet sitesinde (https://www.kolayyolla.app) yayımlanarak kişisel veri
                sahiplerinin erişimine sunulacaktır.
              </span>
            </p>

            <p className={classes.paragraph}><span>Kişisel Verilerin İşlenme Şartları ve Amaçları</span></p>

            <p className={classes.paragraph}>
              <span>
                Kanun'un 4. maddesi uyarınca kişisel veriler,
                Kanun ve diğer ilgili mevzuatta öngörülen usul ve esaslara uygun bir şekilde
                işlenmelidir. Bu kapsamda &quot;veri sorumluları&quot;; hukuka ve dürüstlük
                kurallarına uygun olma, doğru ve gerektiğinde güncel olma, belirli, açık ve
                meşru amaçlar için işlenme, işlendikleri amaçla bağlantılı, sınırlı ve ölçülü
                olma, ilgili mevzuatta öngörülen veya işlendikleri amaç için gerekli olan süre
                kadar muhafaza edilme ilkelerine uymakla yükümlü kılınmıştır.
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Kişisel veriler, prensip olarak ancak kişisel
                veri sahibinin açık rızası bulunan hallerde işlenebilmektedir. Kanun'un 5.
                maddesinde kişisel veriler ile 6. maddesinde özel nitelikli kişisel verilerin
                işlenmesine ilişkin şartlara yer verilmiştir. Kanun, hukuka aykırı olarak
                işlendiğinde kişilerin mağduriyetine veya ayrımcılığa sebep olma riski taşıyan
                kişisel verileri &quot;özel nitelikli kişisel veri&quot; olarak belirlemiştir.
                Kanun'un 6. maddesinde özel nitelikli kişisel veriler sınırlı bir şekilde
                sayılmıştır ve bunlar kişilerin ırkı, etnik kökeni, siyasi düşüncesi, felsefi
                inancı, dini, mezhebi veya diğer inançları, kılık ve kıyafeti, dernek, vakıf ya
                da sendika üyeliği, sağlığı, cinsel hayatı, ceza mahkûmiyeti ve güvenlik
                tedbirleriyle ilgili verileri ile biyometrik ve genetik verilerini
                içermektedir.
                {' '}
              </span>
            </p>

            <p className={classes.paragraph}><span>Kişisel veriler;</span></p>

            <p className={classes.paragraph}>
              <span>
                · Verilerin işlenmesine ilişkin
                faaliyette bulunmanın kanunlarda açıkça öngörülmesi,
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Fiili imkansızlık nedeniyle rızasını
                açıklayamayacak durumda bulunan veya rızasına hukuki geçerlilik tanınmayan
                kişinin kendisinin ya da bir başkasının hayatı veya beden bütünlüğünün
                korunması için ilgili verilerin işlenmesinin zorunlu olması,
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Bir sözleşmenin kurulması veya
                ifasıyla doğrudan doğruya ilgili olmasından dolayı, kişisel verilerinizin
                işlenmesinin gerekli olması,
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · KolayYolla veri sorumlusunun hukuki
                yükümlülüğünü yerine getirebilmesi için veri işlemenin zorunlu olması,
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Kişisel verilerin ilgili kişinin
                kendisi tarafından alenileştirilmiş olması,
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                ·Bir hakkın tesisi, kullanılması veya
                korunması için veri işlemenin zorunlu olması ve
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · İlgili kişinin temel hak ve
                özgürlüklerine zarar vermemek kaydıyla, veri sorumlusunun meşru menfaatleri
                için veri işlenmesinin zorunlu olması hallerinde gerekli aydınlatmanın yapılmış
                olması koşuluyla veri sahibinin önceden alınmış açık rızası bulunmasa dahi
                işlenebilecektir.
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Kişisel veriler, KolayYolla tarafından
                aşağıdaki amaçlarla işlenmektedir:
              </span>
            </p>

            <p className={classes.paragraph}><span>· Bilgi güvenliği denetimi</span></p>

            <p className={classes.paragraph}>
              <span>
                ·Bilgi teknolojileri alt yapısının
                kurulması ve yönetilmesi
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Çalışanların bilgiye erişim yetki
                kontrolü
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Finans - muhasebe - hukuk işlerinin
                takibi
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · İş faaliyetlerinin planlanması ve
                verimlilik analizlerinin yapılması
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                ·Market temsilcilerinin ve iş
                ortaklarının bilgiye erişim yetkilerinin kontrolü ve ilişkilerinin yönetimi
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Müşteri ilişkileri yönetimi,
                memnuniyeti ve şikayet takibi ve satış sonrası destek hizmeti
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Sunulan hizmetlerden en yüksek faydanın
                elde edilmesi
              </span>
            </p>

            <p className={classes.paragraph}><span>· Pazarlama süreçlerinin planlanması</span></p>

            <p className={classes.paragraph}>
              <span>
                · Verilerin doğru ve güncel olmasının
                sağlanması
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Yetkili kuruluşlara mevzuattan
                kaynaklı bilgi verilmesi
              </span>
            </p>

            <p className={classes.paragraph}><span>Kişisel Verilerin Aktarılması</span></p>

            <p className={classes.paragraph}>
              <span>
                Kişisel verilerin üçüncü bir tarafla
                aktarılması için ilgili veri sahibinden bu doğrultuda açık rıza alınmış olması
                gerekmektedir. KolayYolla kişisel verileri veri işleme amaçları doğrultusunda
                gerekli güvenlik önlemlerini alarak veri sahibinin kişisel verilerini üçüncü
                kişilere aktarabilmektedir.
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Kanun'un 8. Ve 9. maddelerine göre veri
                işlemeye izin verilen şartlarda veri aktarımı da gerçekleştirilebilmekte olup
                bu doğrultuda yukarıda belirtilen şartların varlığı halinde veri sahibinin
                rızası bulunmasa dahi kişisel veri veya özel nitelikli kişisel veri aktarımı
                yapılabilecektir.
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                KolayYolla, restoran temsilcileri ile sözleşme
                kapsamındaki amaçların yerine getirilmesi için sınırlı olarak restoranlara,
                iştiraklere ve hukuki yetkileri dahilinde talep ettikleri amaçla sınırlı olarak
                ilgili kamu kurum ve kuruluşları ile özel hukuk kişileriyle veri sahibinin
                kişisel verilerini aktarabilir.
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Kanun, kişisel verilerin yurtdışına aktarımı,
                veri sahibinin açık rızasının bulunmasına bağlıdır. Ancak veri aktarılan ülkede
                yeterli koruma bulunması veya o ülkedeki veri sorumlusunun yeterli korumayı
                KolayYolla veri sorumlusuna taahhüt ettiği takdirde veri sahibinin rızası
                bulunmadan da veri aktarımı yapılabilmektedir.
              </span>
            </p>

            <p className={classes.paragraph}><span>Kişisel Verilerin Korunması</span></p>

            <p className={classes.paragraph}>
              <span>
                KolayYolla, işlediği kişisel verilerin
                güvenliğini sağlamak için ilgili mevzuat uyarınca öngörülen ve KVK Kurulu
                tarafından bildirilecek olan diğer idari ve teknik önlemleri alarak kişisel
                verilerin hukuka uygun olarak işlenmesini ve korunmasını temin etmektedir. Bu
                kapsamda KolayYolla, kişisel verilerin hukuka uygun olarak işlenmesi, güvenli
                ortamlarda saklanması, yetkisiz erişim riskleri ile diğer her türlü hukuka
                aykırı erişimlerin önlenmesi, arızi olarak gerçekleşen veri kayıplarının
                önlenmesi, verilere kasıtlı olarak zarar verilmesi ile silinmesinin önlenmesi
                için teknolojik imkanlar ve uygulama maliyetinin de ele alındığı makul
                derecedeki teknik ve idari önlemleri almaktadır.
              </span>
            </p>

            <p className={classes.paragraph}><span>Veri Sahibi ve Kişisel Veri Kategorizasyonu</span></p>

            <p className={classes.paragraph}>
              <span>
                Şirketimiz tarafından kişisel veriler, aşağıda
                tanımlı kategoriler altında işlenmektedir:
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Kimlik Bilgisi: Ad, soyadı, doğum
                tarihi
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Lokasyon Bilgisi: İl, ilçe, Mahalle,
                Konum
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · İletişim Bilgisi: cep telefonu,
                e-posta adresi, adres
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Müşteri/Üye Bilgisi: Üyelik bilgisi,
                üyelik ID numarası
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Müşteri/Üye İşlem Bilgisi: Satın
                alınan ürünler, alışveriş tutarı, alışveriş tarihi, çağrı merkezi görüşme
                kayıtları, ticari iletişim izni, siparişe ilişkin bilgiler,
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Pazarlama Bilgisi: Çerez kayıtları,
                hedefleme bilgileri, alışkanlık ve beğenileri gösteren değerlendirmeler
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · İşitsel Veri: Çağrı merkezi görüşme
                kayıtları
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Hukuki İşlem ve Uyum Bilgisi:
                Verilen hizmetin başlama ve bitiş zamanı, yararlanılan hizmetin türü, aktarılan
                veri miktarı, İlgili Kişi'nin elektronik ortamda verdiği ticari elektronik
                ileti izni, onay verdiği üyelik sözleşmesi, kurumsal üyelik sözleşmesi,
                mesafeli satış sözleşmesi ve Doğuş Planet tarafından sunulan hizmetlerden
                faydalanılmasını sağlayan sair hukuki metinler ve sözleşmeler
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                ·Pazarlama Bilgisi: İlgili kişinin
                verdiği ticari elektronik ileti iznine istinaden gönderilen pazarlama amaçlı
                sms, e-posta mesajları veya çağrı merkezi tarafından yapılan aramalar
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Talep Yönetimi Bilgisi: İlgili
                kişinin satın almış olduğu ürün veya hizmete ilişkin web sitesi, mobil
                uygulama, sosyal medya hesapları veya çağrı merkezi üzerinden ilettiği talepler
                ile bu istemlerin değerlendirilmesi
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Kişisel Verilerin Saklanma Süreleri,
                Silinmesi, Yok Edilmesi ve Anonimleştirilmesi
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Kanun kapsamında kişisel verilerin saklanması
                için herhangi bir süre belirlenmemiş olmakla birlikte, genel ilkeler uyarınca
                kişisel verilerin ilgili mevzuatta öngörülen veya işlendikleri amaç için
                gerekli olan süre kadar muhafaza edilmesi esastır. Şirketimiz, söz konusu
                ilkeye uygun bir şekilde saklama süreleri tespit etmek adına, her bir veri
                işleme süreci ile ilgili olarak yürürlükte bulunan mevzuatı ve sürecin amacını
                esas alarak bir değerlendirme yapmaktadır. Bu doğrultuda Şirketimiz, asgari
                olarak yasal yükümlülüklerinin gerektirdiği süre ile ve zamanaşımı süreleri
                dolana kadar kişisel verileri saklamaktadır.
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Kanun kapsamında anonimleştirme &quot;Kişisel
                verilerin, başka verilerle eşleştirilerek dahi hiçbir surette kimliği belirli
                veya belirlenebilir bir gerçek kişiyle ilişkilendirilemeyecek hâle
                getirilmesi&quot; şeklinde tanımlanmıştır. Şirketimiz anonimleştirme
                faaliyetleri yürürlükteki mevzuata uygun bir şekilde gerçekleştirilmektedir.
                Şirketimiz, ilgili kişisel verinin işleme amacının ortadan kalkması ile
                birlikte kişisel verileri Kanun'a uygun bir şekilde anonimleştirmekte, silmekte
                veya yok etmektedir.
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Kişisel Veri Sahibinin Aydınlatılması, Hakları
                ve Bilgilendirilmesi
              </span>
            </p>

            <p className={classes.paragraph}><span>Kanun'un 11. maddesi uyarınca veri sahipleri;</span></p>

            <p className={classes.paragraph}>
              <span>
                · Kendileri ile ilgili kişisel veri işlenip
                işlenmediğini öğrenme,
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Kişisel verileri işlenmişse buna
                ilişkin bilgi talep etme,
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Kişisel verilerin işlenme amacını ve
                bunların amacına uygun kullanılıp kullanılmadığını öğrenme,
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Yurt içinde veya yurt dışında
                kişisel verilerin aktarıldığı üçüncü kişileri bilme,
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Kişisel verilerin eksik veya yanlış
                işlenmiş olması hâlinde bunların düzeltilmesini isteme ve bu kapsamda yapılan
                işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Kanun ve ilgili diğer kanun
                hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren
                sebeplerin ortadan kalkması hâlinde kişisel verilerin silinmesini veya yok
                edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı
                üçüncü kişilere bildirilmesini isteme,
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · İşlenen verilerin münhasıran
                otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi
                aleyhine bir sonucun ortaya çıkmasına itiraz etme ve
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                · Kişisel verilerin kanuna aykırı
                olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep
                etme haklarına sahiptir.
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Söz konusu hakların kullanımına ilişkin
                talepler, ilgili veri sahibinin kimliğini tespit edecek belgelerle birlikte,
                formun ıslak imzalı bir kopyasının elden veya noter aracılığıyla ya da Kanun'da
                belirtilen diğer yöntemler ile KOLAYYOLLA TEKNOLOJİ HİZMETLERİ DİJİTAL
                PAZARLAMA VE TİCARET ANONİM ŞİRKETİ Kısıklı Cad. No:22 Altunizade Üsküdar
                İstanbul adresine iletilmesi veya Şirketimiz'e daha önce bildirilen ve
                Şirketimiz sisteminde kayıtlı bulunan
                <a href="mailto:info@kolayyolla.com.tr">info@kolayyolla.com.tr</a>
                elektronik posta adresinden gönderilecek e-mail ile gerçekleştirilebilmektedir.
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                KolayYolla, söz konusu talepleri
                değerlendirerek 30 gün içerisinde sonuçlandıracaktır. KolayYolla’nın taleplere
                ilişkin olarak Kişisel Verileri Koruma Kurulu tarafından belirlenen (varsa)
                ücret tarifesi üzerinden ücret talep etme hakkı saklıdır.
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Veri sahipleri, yukarıda bahsi geçen hakları
                kullanmak için KVK Başvuru Formu'nu kullanabileceklerdir.
              </span>
            </p>

          </div>
        </Grid>

      </Grid>

    </>
  )
}
export default KVKK
